// Default data used the first time the site loads in a browser.
// After that, everything is edited from the admin panel (/admin) and kept in localStorage.

const unsplash = (id) =>
    `https://images.unsplash.com/${id}?w=800&h=800&fit=crop&crop=faces&auto=format&q=80`;

export const seedAuthors = [
    {
        id: "author-james",
        name: "James Whitmore",
        role: "Senior Automotive Technician",
        bio: "James has spent over 15 years in independent London garages, specialising in engine and drivetrain repairs.",
        avatar: "",
    },
    {
        id: "author-sophie",
        name: "Sophie Harrington",
        role: "Motoring Editor",
        bio: "Sophie writes practical guides that help UK drivers understand servicing, MOTs and running costs.",
        avatar: "",
    },
    {
        id: "author-oliver",
        name: "Oliver Bennett",
        role: "MOT Tester & Service Advisor",
        bio: "Oliver is a DVSA-approved MOT tester who helps customers keep their cars safe and road-legal.",
        avatar: "",
    },
    {
        id: "author-charlotte",
        name: "Charlotte Hughes",
        role: "Content Writer",
        bio: "Charlotte covers car maintenance, servicing schedules and money-saving tips for motorists.",
        avatar: "",
    },
    {
        id: "author-daniel",
        name: "Daniel Fletcher",
        role: "Diagnostics Specialist",
        bio: "Daniel focuses on modern vehicle electronics, fault codes and emissions systems.",
        avatar: "",
    },
    {
        id: "author-emily",
        name: "Emily Clarke",
        role: "Garage Operations Writer",
        bio: "Emily works with garages across the UK on operations, parts and customer experience.",
        avatar: "",
    },
];

export const seedTeam = [
    {
        id: "team-adam",
        name: "Adam Rahman",
        role: "Sales Manager",
        description: "Handling portal business partner",
        photo: unsplash("photo-1557862921-37829c790f19"),
    },
    {
        id: "team-jordan",
        name: "Jordan Ellis",
        role: "Sales Executive",
        description: "Responsible for sales strategy, partnership development, and client success",
        photo: unsplash("photo-1531427186611-ecfd6d936c79"),
    },
    {
        id: "team-liam",
        name: "Liam Carter",
        role: "Parts Procurement",
        description: "Handles OEM & aftermarket automotive parts, with global supplier connections",
        photo: unsplash("photo-1599566150163-29194dcaad36"),
    },
    {
        id: "team-sarah",
        name: "Sarah Mitchell",
        role: "Project Head",
        description: "Leads UK and EU sales partnerships and project direction",
        photo: unsplash("photo-1573496359142-b8d87734a5a2"),
    },
    {
        id: "team-marcus",
        name: "Marcus Reid",
        role: "Assistant Project Head",
        description: "Expands B2B networks and manages Gulf workshop operations",
        photo: unsplash("photo-1566492031773-4f4e44671857"),
    },
    {
        id: "team-tom",
        name: "Tom Harper",
        role: "Marketing Manager",
        description: "Drives marketing campaigns and UK–EU brand growth",
        photo: unsplash("photo-1568602471122-7832951cc4c5"),
    },
];

export const seedSettings = {
    companyName: "MM AutoTech LTD",
    addressLine1: "13 The Common Southhall, London,",
    addressLine2: "United Kingdom UB2 5JF",
    phone: "+447747762059",
    whatsapp: "+447747762059",
    landline: "",
    email: "mmautotechltd@gmail.com",
    hoursWeekdays: "Mon - Sat: 9:00 AM - 6:00 PM",
    hoursWeekend: "Sunday: Closed",
};
